<template>
    <div class="form">
        <div class="col-12 ml-3 pr-5">
            <div class="row">
                <span>{{ title }}</span>
            </div>
            <div class="row">
                <core-lever
                    label="Zakelijk"
                    labelClass="ml-2"
                    v-model.number="item.isBusiness"
                ></core-lever>
            </div>
            <div class="row">
                <core-gender
                    class="col-sm-12 mt-4 input-group"
                    :selectedValue.sync="item.genderId"
                ></core-gender>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-12 mt-4"
                    :config="{label: 'Voornaam', name: 'firstName'}"
                    :hasContent="item.firstName"
                >
                  <input
                      type="text"
                      v-model="item.firstName"
                  />
                </core-floating-label>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-12"
                    :config="{label: 'Achternaam', name: 'lastName'}"
                    :hasContent="item.lastName"
                >
                  <input
                      type="text"
                      v-model="item.lastName"
                  />
                </core-floating-label>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-12"
                    :config="{label: 'E-mailadres', name: 'email'}"
                    :hasContent="item.email"
                >
                  <input
                      type="text"
                      v-model="item.email"
                  />
                </core-floating-label>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-12"
                    :config="{label: 'Telefoonnummer', name: 'phoneNumber'}"
                    :hasContent="item.phoneNumber"
                >
                  <input
                      type="text"
                      v-model="item.phoneNumber"
                  />
                </core-floating-label>
            </div>
            <div class="row">
                <div class="col-sm-12 mt-2 px-0 input-group">
                    <core-calendar
                        :key="item.dateOfBirth"
                        :date.sync="item.dateOfBirth"
                        :inputProps="{placeholder: 'Geboortedatum'}"
                    ></core-calendar>
                </div>
            </div>
            <div class="row">
                <core-language
                    class="col-sm-12 mt-4 input-group"
                    :selectedValue.sync="item.languageId"
                ></core-language>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-8 mt-4"
                    :config="{label: 'Straat', name: 'address'}"
                    :hasContent="item.addressLine1"
                >
                    <input
                        type="text"
                        v-model="item.addressLine1"
                    />
                </core-floating-label>
                <core-floating-label
                    class="mt-4 col-sm-4"
                    :config="{label: 'Huisnummer', name: 'houseNr'}"
                    :hasContent="item.addressLine2"
                >
                  <input
                      type="text"
                      v-model="item.addressLine2"
                  />
              </core-floating-label>
            </div>
            <div class="row">
                <core-floating-label
                    class="col-sm-4"
                    :config="{label: 'Postcode', name: 'postcalCode'}"
                    :hasContent="item.postalCode"
                >
                    <input
                        type="text"
                        v-model="item.postalCode"
                    />
                </core-floating-label>
                <core-floating-label
                    class="col-sm-8"
                    :config="{label: 'Plaats', name: 'city'}"
                    :hasContent="item.city"
                >
                  <input
                      type="text"
                      v-model="item.city"
                  />
              </core-floating-label>
            </div>
            <div class="row">
                <core-drop-down
                    v-if="countries.length"
                    style="height: 34px"
                    class="col-sm-12 input-group"
                    searchable
                    :items="countries"
                    labelAttribute="name_NL"
                    valueAttribute="id"
                    :selectedValue.sync="item.countryId"
              ></core-drop-down>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center mt-4">
                    <button class="btn-custom btn-custom-send" @click.prevent="save">
                        <img class="mr-3 mb-1" src="@/assets/svg/save-ffffff.svg">
                        <span class="mr-5 text-uppercase">Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Person from '@/services/hatsApi/Person'
export default {
  props: {
    person: {
      default: () => ({
        dateOfBirth: null
      }),
      type: Object,
      required: false
    }
  },
  data () {
    return {
      countries: this.$store.getters.countries,
      item: this.person,
      title: null
    }
  },
  created () {
    if (this.person.hasOwnProperty('id')) {
      this.title = 'Details klantnr. ' + this.person.customerNumber
    } else {
      this.title = 'Nieuwe klant'
    }
    const countryObject = this.countries.find(c => c.id === this.item.countryId)
    if (countryObject) {
      this.$set(this.item, 'countryId', countryObject)
    }
    this.$set(this.item, 'genderId', (this.item.gender ? this.item.gender.id : null))
  },
  methods: {
    async save () {
      try {
        let personResponse = null
        if (this.item.countryId && this.item.countryId.hasOwnProperty('id')) {
          this.$set(this.item, 'countryId', this.item.countryId.id)
        }
        this.$set(this.item, 'gender', this.item.genderId)

        if (this.person.hasOwnProperty('id')) {
          personResponse = await Person.updatePerson(this.item)
        } else {
          personResponse = await Person.createPerson(this.item)
        }
        if (personResponse.data.success) {
          this.$emit('saved', personResponse.data.data)
        }
      } catch (error) {
        console.error(error)
        this.$emit('saved', {})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/Form.vue